// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__VG3fN","topBottomGutter":"Layout_topBottomGutter__UqShy"};